import React from "react";
import { Box, Container, Link, Typography } from "@mui/material";

export function Footer(): JSX.Element {
  return (
    <Box component="footer" sx={{
        backgroundColor: '#0b3a5d',
        padding: '20px 0',
        color: 'white',
    }}>
    <Container>
      <Box>
        <Typography className="footer-text" component="p">
          Alignment Health Plan is an HMO, HMO POS, HMO C-SNP, HMO D-SNP and PPO
          plan with a Medicare contract and a contract with the California,
          Nevada, North Carolina and Texas Medicaid programs. Enrollment in
          Alignment Health Plan depends on contract renewal. Alignment Health
          Plan complies with applicable federal civil rights laws and does not
          discriminate on the basis of race, color, national origin, age,
          disability, or sex.{" "}
            <Link
              id="disclaimer-link"
              href={`https://www.alignmenthealthplan.com/about-us/terms-of-use`}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: 'white',
                textDecoration: 'underline',
                '&:hover': {
                  color: 'white',
                  textDecoration: 'none',
                },
              }}
            >
              Click here to read the full disclaimer.
            </Link>
        </Typography>
      </Box>
      <Box className="metadata-container">
        <div>
          <Typography>
            ©Copyright {new Date().getFullYear()} Alignment Health Plan. All
            Rights Reserved
          </Typography>
        </div>
        <div>
          <Typography>Page last updated on October 1, 2025 | {"Y0141_26471EN_M"}</Typography>
        </div>
      </Box>
    </Container>
    </Box>
  );
}

export default Footer;
